import { BaseEntity } from "../../base-models/base-entity";
import { CryptoService } from "../../base-services/crypto.service";

export class TableContextMenuItem {
    ID: number = null;
    Name: string = null;
    Action: string = null;
    Label: string = null;
    Indicator: string = null;
    IsEnabledFunction: (item: BaseEntity) => boolean;
    IsVisibleFunction: (item: BaseEntity) => boolean;  
    Parameters?: any;

    LoadItems(data: any, userRightsModelName: string) {
      let items: TableContextMenuItem[] = [];
      const encrypted = sessionStorage.getItem('yt-user-rights');
      let userRights;

      if (encrypted) {
        try {
          userRights = CryptoService.Decrypt(encrypted);
        } catch (e) {
          console.error('Decription failed:', e)
        }
      }
        
        if (data) {
            data.forEach(dataItem => {
                if (
                  userRights &&
                  userRights.Values[userRightsModelName] &&
                  userRights.Values[userRightsModelName][dataItem.Action]
                ) {
                    let item = new TableContextMenuItem();
                    item.Name = dataItem.Name;
                    item.Action = dataItem.Action;
                    item.Label = dataItem.Label;
                    item.Indicator = dataItem.Indicator ? String(dataItem.Indicator) : null;
                    item.IsEnabledFunction = dataItem.IsEnabledFunction ? dataItem.IsEnabledFunction : (() => true);
                    item.IsVisibleFunction = dataItem.IsVisibleFunction ? dataItem.IsVisibleFunction : (() => true);
                    
                    if (dataItem.Parameters) {
                        item.Parameters = dataItem.Parameters;
                    }
                    
                    if (item.Indicator !== null) {
                        items.push(item);
                    } 
                    else if (item.Indicator === null) {
                        items.push(item);
                    }
                }
            });
        }
    
        return items;
    }
    
}
